module.exports = __webpack_public_path__ + "static/media/andres.c258342c.png";